import type { ReactNode } from 'react';

import { ROUTER_DIAGRAMS, ROUTER_INDEX, ROUTER_TEMPLATE_LIST } from '@/entry/route';

export type NavMenuItem = {
  name: string;
  key: string;
  path: string;
  icon: ReactNode;
  disableNavigate?: boolean;
};

export type NavMenuGroups = {
  primary: NavMenuItem[];
  secondary: NavMenuItem[];
};

export function getCanvopixMenuGroups(icons: {
  home: ReactNode;
  projects: ReactNode;
  templates: ReactNode;
  help: ReactNode;
}): NavMenuGroups {
  return {
    primary: [
      {
        name: 'layout.sider.home',
        key: 'home',
        path: ROUTER_INDEX,
        icon: icons.home,
      },
      {
        name: 'layout.sider.project',
        key: 'diagrams',
        path: ROUTER_DIAGRAMS,
        icon: icons.projects,
      },
      {
        name: 'layout.sider.template',
        key: 'templates',
        path: ROUTER_TEMPLATE_LIST,
        icon: icons.templates,
      },
    ],
    secondary: [
      {
        name: 'layout.header.help_center',
        key: 'help',
        path: 'help',
        icon: icons.help,
        disableNavigate: true,
      },
    ],
  };
}
